import React, { useEffect, useState } from "react";
import Header from "../../components/Layout/Header";
import PrivacyPolicyMain from "./PrivacyPolicyMain";
import BackToTop from "../../components/elements/BackToTop";

const PrivacyPolicy = () => {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScroll && window.pageYOffset > 300) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 300) {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);

    return () => {
      window.removeEventListener("scroll", checkScrollTop);
    };
  }, [showScroll]);

  return (
    <React.Fragment>
      <Header />
      <PrivacyPolicyMain />
      {showScroll && <BackToTop />}
    </React.Fragment>
  );
};

export default PrivacyPolicy;
